import { type ImportResult } from "@milqit/shared-types";
import {
  type CategoryImportRow,
  type ImportPreview,
  type ProductImportRow,
} from "@milqit/validations";

import type { SheetRow } from "../spreadsheet";
import { apiFetch } from "./client";

/** A few hundred rows are written in one transaction; give it longer than an ordinary call. */
const IMPORT_TIMEOUT_MS = 120_000;

/** What importing these (already parsed) rows would do, checked by the API against the catalogue. */
export async function previewProductImport(rows: ProductImportRow[]): Promise<ImportPreview> {
  return apiFetch("/admin/products/import/preview", {
    method: "POST",
    body: JSON.stringify({ rows }),
  });
}

export async function previewCategoryImport(rows: CategoryImportRow[]): Promise<ImportPreview> {
  return apiFetch("/admin/categories/import/preview", {
    method: "POST",
    body: JSON.stringify({ rows }),
  });
}

/** Rows as read from the sheet; the API checks them with the shared schemas. */
export async function importProducts(rows: SheetRow[]): Promise<ImportResult> {
  return apiFetch("/admin/products/import", {
    method: "POST",
    body: JSON.stringify({ rows }),
    timeoutMs: IMPORT_TIMEOUT_MS,
  });
}

export async function importCategories(rows: SheetRow[]): Promise<ImportResult> {
  return apiFetch("/admin/categories/import", {
    timeoutMs: IMPORT_TIMEOUT_MS,
    method: "POST",
    body: JSON.stringify({ rows }),
  });
}
